"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobile = exports.getBlobUrl = exports.formatDateTime = exports.deriveDuration = void 0;
var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url"));
var _moment = _interopRequireDefault(require("moment"));
/**
 * Determine if the user is on a mobile device
 */
const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

/**
 * Get a temporary url pointing to an in memory ICS calendar blob object
 *
 * @param {string} url - the calendar "url" (ICS string) to return a blob url for
 */
exports.isMobile = isMobile;
const getBlobUrl = url => {
  let blob = new Blob([url], {
    type: 'text/calendar;charset=utf-8'
  });
  return _url.default.createObjectURL(blob);
};

/**
 * Convert a dateTime string into the format recognized by calendar applications
 *
 * @param {string} dateTime - string (including date and time) to be formatted to ISO
 */
exports.getBlobUrl = getBlobUrl;
const formatDateTime = dateTime => _moment.default.utc(dateTime).format('YYYYMMDDTHHmmss[Z]');

/**
 * Derive an HHmm formatted duration string representing the duration between two times on the same day
 *
 * @param {string} start - ISO date-time string representing the beginning of an event
 * @param {string} end - ISO date-time string representing the end of an event
 */
exports.formatDateTime = formatDateTime;
const deriveDuration = (start, end) => {
  const startDateTime = _moment.default.utc(start);
  const endDateTime = _moment.default.utc(end);
  const diff = endDateTime.diff(startDateTime);
  return _moment.default.utc(diff).format('HHmm');
};
exports.deriveDuration = deriveDuration;